<div class="h-full w-full flex flex-column align-items-start justify-content-between">
	<div class="w-full h-3rem flex align-items-center justify-content-center gap-2">
		<span class="font-semibold text-xl">{{ conversation?.title }}</span>
		@if (conversation && !conversation.private && !conversation.new) {
		<p-button [icon]="conversation.hasStatus(Status.Followed) ? 'fa-solid fa-bell' : 'fa-regular fa-bell'"
			[text]="true" [rounded]="true"
			[pTooltip]="conversation.hasStatus(Status.Followed) ? 'Ne plus suivre' : 'Suivre cette conversation'"
			tooltipPosition="bottom" (click)="onToggleFollow()"></p-button>
		}
		@if (conversation?.private && participantsToShow.length > 0) {
		<p-avatarGroup>
			@for (participant of participantsToShow; track participant) {
			<app-avatar [user]="participant.user" [label]="getParticipantLabel(participant)"
				[pTooltip]="participant.fullName" tooltipPosition="bottom"></app-avatar>
			}
			@if (participantsOverflow > 0) {
			<p-avatar [label]="'+' + participantsOverflow" shape="circle"
				[style]="{ 'background-color': 'var(--surface-300)' }"></p-avatar>
			}
		</p-avatarGroup>
		}
	</div>
	<div class="w-full flex flex-column flex-grow-1 align-items-start justify-content-between p-5 overflow-auto">
		@if (!loading) {
		<div #messageContainer class="flex flex-column w-full flex-1 overflow-auto">
			@if (hasVisibleMessages) {
			@for (item of conversation!.items; track item.id; let i = $index) {
			@if (!item.hasStatus(Status.Draft)) {
			@if (i === firstUnreadItemIndex) {
			<p-divider align="center" type="solid">
				<b>Non lu(s)</b>
			</p-divider>
			}
			<div>
				<app-conversation-details-item [item]="item"></app-conversation-details-item>
			</div>
			}
			}
			} @else {
			<!-- État vide : aucun message envoyé -->
			<div class="flex-1 flex flex-column align-items-center justify-content-center text-center gap-3 p-4">
				<i class="fa-solid fa-comments text-300" style="font-size: 4rem"></i>
				<span class="text-color-secondary text-lg">Aucun message n'a encore été envoyé dans cette
					conversation</span>
			</div>
			}
		</div>
		<div class="w-full pt-5">
			<app-conversation-item-form [conversation]="conversation!"
				(itemSaved)="onItemSaved()"
				(conversationCreated)="onConversationCreated($event)"></app-conversation-item-form>
		</div>
		} @else {
		<div class="h-full w-full flex align-items-center justify-content-center">
			<p-progressSpinner></p-progressSpinner>
		</div>
		}
	</div>
</div>